import { render } from "./counsel.vue?vue&type=template&id=a6d2187e&scoped=true&ts=true"
import script from "./counsel.vue?vue&type=script&lang=ts&config=true"
export * from "./counsel.vue?vue&type=script&lang=ts&config=true"

import "./counsel.vue?vue&type=style&index=0&id=a6d2187e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d2187e"]])

export default __exports__